<div class="header-bg">
  <app-navbar></app-navbar>
</div>
